<ion-list class="ion-no-margin ion-no-padding">
  <ion-item button [disabled]="!hasGrantToWriteField" (click)="onClickEditGeometry()">{{'MARKER.EDIT.BORDERS'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteField" (click)="onClickEditInformation()">{{'EDIT'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteField" *ngIf="!fieldDTO.active" (click)="onClickActivate()">{{'ACTIVATE'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteField" *ngIf="fieldDTO.active" (click)="onClickDeactivate()">{{'DEACTIVATE'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteField" (click)="onClickDelete()">{{'DELETE'|translate}}</ion-item>
</ion-list>

